<template>
    <div class="h-full">
        <div :class="config.isDetailDisplay ? 'small-list' : 'scroll-auto'">
            <Control ref="control" :config="config" @onChangeEditDataSource="onChangeEditDataSource"></Control>
        </div>
        <div v-show="config.isDetailDisplay" class="detail">
            <EditControl :dataSource="editDataSource" :dbType="dbType" :config="config"></EditControl>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                config: {
                    isDetailDisplay: false,
                },
                editDataSource: {},
                initialDataSource: {},
                dbType:[]
            }
        },
        mounted() {
            this.loadTypes();
        },
        methods: {
            onChangeEditDataSource: function (dataSource) {
                this.editDataSource = dataSource;
                this.initialDataSource = this.Utils.extend({}, dataSource);
            },
            syncDataSource() {
                this.initialDataSource = this.Utils.extend({}, this.editDataSource);
            },
            checkSaveStatus() {
                this.config.isDetailDisplay = false;
            },
            loadTypes() {
                this.$ajax.send("omsapi/optenterprise/getdbtypelist", "get", {}, data => {
                    this.dbType = data.Result;
                });
            }
        },
        components: {
            "EditControl": resolve => { require(['./components/editoperatorinfo.vue'], resolve) },
            "Control": resolve => { require(['./components/operatorinfo.vue'], resolve) },
        }
    }
</script>

<style>
</style>